module.exports = __webpack_public_path__ + "fea0120c8d8bbbe5f1ecb65f8271b44f.png";